<template>
  <div class="group flex w-full pl-10">
    <a :href="editUrl" target="_blank">
      <div
          :title="loading ? 'Loading...' : reason"
          class="dot w-4 h-4 rounded-full border border-gray-300"
          :class="{'bg-green-500': isLocalized, 'bg-red-200': isLocalized === false, 'border-dashed border-gray-400': loading}"/>
    </a>
    <button data-reload-block @click="fetchStatus" class="group-hover:block hidden ml-2 text-gray-600">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path></svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "LocalizationStatusDot",

  props: ['endpoint', 'editUrl'],

  data() {
    return {
      isLocalized: null,
      reason: null,
      loading: true,
    }
  },

  mounted() {
    // this.fetchStatus();
  },

  methods: {
    fetchStatus() {
      this.loading = true;
      this.isLocalized = null;
      this.reason = null;
      fetch(this.endpoint).then(response => response.json()).then(result => {
        this.isLocalized = result.data.isLocalized;
        this.reason = result.data.reason;
        this.loading = false;
      })
    }
  }
}
</script>
